export default "__VITE_ASSET__C7PwemFT__"